export default __webpack_public_path__ + "static/epica-lite-7-9823f70404e9287d491c96ee5275dbac.jpg";